module.exports = __webpack_public_path__ + "static/target-29b1b99ba6fdc0dfaddb09e0adc303a6.svg";